import logo from "../img/headrlogo.png";
import Box from '@mui/material/Box';
import { Button, Grid, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
export default function Page404() {
    const navigate = useNavigate()
    return (
        <Grid sx={{ textAlign: 'center', }}>
            <Box sx={{ alignContent: 'center', height: '500px' }}>
                <img src={logo} alt='404' width={300} />
                <Typography variant='h5' sx={{ margin: 3 }}> 404 |  <small>File Not Found</small></Typography>
                <Button variant='outlined' onClick={() => navigate(-1)}><ArrowBackIcon /> &nbsp; Back</Button>
            </Box>
        </Grid>
    )
}
